// Terms of numerals and word building (Kielioppi § 7, 07-words.mdx; lessons 25, 48).
// HV facts as 07-words.mdx states them (wiki: Numbers, Tips & Notes, the derivation list).
import { defineTerms } from './define';

export const terms = defineTerms({
  lukusana: {
    fi: {
      name: 'lukusana',
      short: '**Lukusana** ilmaisee määrää, kuten *yksi*, *kaksi* tai *sata*.',
      compare: 'Valyria laskee kymmenjärjestelmässä kuten suomikin, mutta luvut taipuvat eri tavoin: lukusanan jälkeen ei ole partitiivia.',
      long: 'Luvut 1–9 ovat adjektiiveja ja mukautuvat substantiiviinsa. Kymmenet ja sadat eivät taivu, ja tuhat on substantiivi.',
    },
    en: {
      name: 'numeral',
      short: 'A **numeral** expresses an amount, such as *one*, *two* or *a hundred*.',
      compare: 'High Valyrian counts in tens like Finnish, but its numbers inflect differently: there is no partitive after a numeral.',
      long: 'The numbers 1–9 are adjectives and agree with their noun. The tens and hundreds do not inflect, and a thousand is a noun.',
    },
    related: ['jarjestysluku', 'adjektiivi', 'partitiivi'],
    firstIn: 'numerals',
  },
  jarjestysluku: {
    fi: {
      name: 'järjestysluku',
      short: '**Järjestysluku** kertoo järjestyksen: *ensimmäinen*, *toinen*.',
      compare: 'Kuten suomessa ensimmäiset ovat epäsäännöllisiä (*yksi* → *ensimmäinen*); valyrian järjestysluvut ovat III-luokan adjektiiveja.',
    },
    en: {
      name: 'ordinal',
      short: 'An **ordinal** tells the order: *first*, *second*.',
      compare: 'As in Finnish, the first ones are irregular (*yksi* → *ensimmäinen*); High Valyrian ordinals are class III adjectives.',
    },
    related: ['lukusana', 'adjektiiviluokka'],
    firstIn: 'numerals',
  },
  yhdyssana: {
    fi: {
      name: 'yhdyssana',
      short: '**Yhdyssana** on kahdesta tai useammasta sanasta yhdistetty sana, kuten *lohikäärme|kivi*.',
      compare: 'Suomessa yhdyssanoja on paljon, valyriassa vähän: valyria rakentaa uudet sanat johtimilla ja etuliitteillä.',
      long: 'Yhdyssanoja on lähinnä nimissä, ja niissä määriteosa tulee ensin kuten suomessa. Etuliitteellinen verbi ei ole yhdyssana.',
    },
    en: {
      name: 'compound',
      short: 'A **compound** is a word made of two or more words, like Finnish *lohikäärme|kivi* ‘Dragonstone’.',
      compare: 'Finnish has many compounds, High Valyrian few: it builds new words with suffixes and prefixes.',
      long: 'Compounds are found mainly in names, and the modifying part comes first, as in Finnish. A verb with a prefix is not a compound.',
    },
    related: ['johdin', 'johdos', 'etuliite'],
    firstIn: 'word-building',
  },
});
